import { capitalize } from 'lodash-es'
import i18n from '@/i18n'

export const getTicketStatusLabel = (status: string) => {
  const selectedValueMap = {
    new: i18n.t('conversations.ticket_event.statuses.new'),
    open: i18n.t('conversations.ticket_event.statuses.open'),
    closed: i18n.t('conversations.ticket_event.statuses.closed'),
    solved: i18n.t('conversations.ticket_event.statuses.solved'),
    pending: i18n.t('conversations.ticket_event.statuses.pending'),
  }

  return selectedValueMap[status.toLocaleLowerCase()] || capitalize(status)
}
